export const Roles = [
    { name: 'ADMIN', code: 'ADMIN' },
    { name: 'TRAVELAGENT', code: 'TRAVELAGENT' },
    { name: 'HOTEL CO-ORDINATOR', code: 'HOTEL CO-ORDINATOR' },
    { name: 'VENUE CO-ORDINATOR', code: 'VENUE CO-ORDINATOR' },
    { name: 'AIRPORT CO-ORDINATOR', code: 'AIRPORT CO-ORDINATOR' },
]